import React, { useState, useEffect } from "react";

import {
  Divider,
  Typography,
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

import moment from "moment";

export default function OccupancyReport({
  data,
  dataHospitals,
  selectedHospitals,
  selectedHospitalsOfOrigins,
  fromDate,
  toDate,
  ...props
}) {
  const [dataGrouped, setDataGrouped] = useState([]);

  useEffect(() => {
    const filteredData =
      selectedHospitalsOfOrigins.length > 0
        ? data.flatMap((hospital) => {
            const filteredPatients = hospital.patients
              .filter((patient) => {
                const isIncluded = selectedHospitalsOfOrigins.includes(
                  patient.hospital_of_origin_id
                );
                return isIncluded;
              })
              .map((patient) => ({
                hospital_name: hospital.hospital_name,
                ...patient,
              }));
            return filteredPatients;
          })
        : data.flatMap((hospital) =>
            hospital.patients.map((patient) => ({
              hospital_name: hospital.hospital_name,
              ...patient,
            }))
          );

    const groupedData = filteredData.reduce((acc, patient) => {
      const hospitalOfOriginId = patient.hospital_of_origin_id;
      const hospitalOfOriginName = patient.hospital_of_origin_name;

      let group = acc.find((group) => group.id === hospitalOfOriginId);

      if (!group) {
        group = {
          id: hospitalOfOriginId,
          name: hospitalOfOriginName,
          patients: [],
        };
        acc.push(group);
      }

      group.patients.push(patient);

      return acc;
    }, []);

    setDataGrouped(groupedData);
  }, [data, dataHospitals, selectedHospitals, selectedHospitalsOfOrigins]);

  return (
    <Grid
      container
      spacing={1}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {dataGrouped !== null && dataGrouped.length > 0 ? (
        <>
          {dataGrouped.map((dataItem) => (
            <Grid
              item
              xs={12}
              md={12}
              style={{ margin: 10, pageBreakAfter: "always" }}
            >
              <Typography variant="h6">{dataItem.name}</Typography>
              <Divider
                orientation="horizontal"
                variant="fullWidth"
                style={{ padding: 2, marginBottom: 15 }}
              />

              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ width: 100 }} align="left">
                        MRN
                      </TableCell>
                      <TableCell style={{ width: 150 }} align="left">
                        Admitted Date
                      </TableCell>
                      <TableCell style={{ width: 150 }} align="left">
                        Discharge Date
                      </TableCell>
                      <TableCell style={{ width: 100 }} align="left">
                        EDD
                      </TableCell>
                      <TableCell style={{ width: 100 }} align="left">
                        Stay Length
                      </TableCell>
                      <TableCell style={{ width: 150 }} align="left">
                        EDD Alignment
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataItem.patients.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="left">{row.mrn}</TableCell>
                        <TableCell align="left">
                          {row.admitted_date
                            ? moment(row.admitted_date).format("DD/MM/YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell align="left">
                          {row.discharge_date
                            ? moment(row.discharge_date).format("DD/MM/YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell align="left">
                          {row.exptected_discharge_date
                            ? moment(row.exptected_discharge_date).format(
                                "DD/MM/YYYY"
                              )
                            : "-"}
                        </TableCell>
                        <TableCell align="left">{row.stay_length}</TableCell>
                        <TableCell align="left">{row.edd_alignment}</TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell colSpan={3} />
                      <TableCell colSpan={1} style={{ fontWeight: "bold" }}>
                        Total
                      </TableCell>
                      <TableCell align="left" style={{ fontWeight: "bold" }}>
                        {dataItem.patients.reduce(
                          (total, patient) => total + patient.stay_length,
                          0
                        )}
                      </TableCell>
                      <TableCell align="left" style={{ fontWeight: "bold" }}>
                        {/* Placeholder for total EDD Alignment */}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          ))}
        </>
      ) : (
        dataGrouped === null && (
          <Typography
            data-test={"reports-empty-msg"}
            style={{ textAlign: "center" }}
          >
            There is no data available for the selected ranges.
          </Typography>
        )
      )}
    </Grid>
  );
}
